import { type OnSelectParam, type Option, Select } from "../select";
import type { OptionsOrGroups } from "react-select";
import { fetchEducation } from "~/utils/fetch_education";

interface Props {
  id: string;
  type: "schools" | "degrees" | "disciplines";
  label: string;
  selected: Option | undefined;
  onSelect: (selected: OnSelectParam) => void;
  required: boolean;
  outsideLabel: boolean;
  error: string | null | undefined;
  onFocus: () => void;
  urlToken: string;
}

export const EducationSelect = ({
  id,
  type,
  label,
  selected,
  onSelect,
  required,
  outsideLabel,
  error,
  onFocus,
  urlToken,
}: Props) => {
  async function loadOptions(
    term: string,
    loadedOptions: OptionsOrGroups<Option, any>,
    additional: any
  ) {
    const page = additional?.page || 1;
    const result = await fetchEducation({ type, urlToken, term, page });

    if (result.status !== 200) {
      throw new Error(`Received ${result.status} fetching ${type}`);
    }

    const options = result.items.map(({ id, text }) => {
      return { value: id, label: text };
    });

    return {
      options,
      hasMore: result.more,
      additional: {
        page: page + 1,
      },
    };
  }

  return (
    <Select
      id={id}
      label={label}
      isAsync={true}
      loadOptions={loadOptions}
      onSelect={onSelect}
      selected={selected}
      isClearable={true}
      required={required}
      outsideLabel={outsideLabel}
      error={error}
      onFocus={onFocus}
    />
  );
};
